<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <v-app-bar
    dark
    app
    color="bar"
    class="d-print-none app-bar"
    :height="60"
    elevation="0"
    flat
    tile
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-btn
      v-if="showDrawerIcon"
      :x-large="AppIsSmall"
      icon
      @click.stop="drawer = !drawer"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <!--<v-avatar-->
    <!--  v-if="!AppIsSmall"-->
    <!--  color="white"-->
    <!--&gt;-->
    <!--  <v-img-->
    <!--    :src="AppIcon"-->
    <!--    :aspect-ratio="1"-->
    <!--  />-->
    <!--  &lt;!&ndash;<router-link&ndash;&gt;-->
    <!--  &lt;!&ndash;  :to="route(APP_ROUTES.homePage)"&ndash;&gt;-->
    <!--  &lt;!&ndash;&gt;&ndash;&gt;-->
    <!--  &lt;!&ndash;</router-link>&ndash;&gt;-->
    <!--</v-avatar>-->

    <!--
      <v-avatar
        v-if="!AppIsSmall"
        :color="logoColor"
      >
        <v-img
          :src="AppLogo"
          class="pointer"
          contain
          @fclick="goToHome"
        />
      </v-avatar>
      -->
    <v-container fluid>
      <v-row
        v-if="!AppIsSmall"
        no-gutters
        align="center"
      >
        <v-col
          cols="auto"
          class="px-2"
        >
          <v-img
            :src="AppDarkLogo"
            class="pointer"
            contain
            width="100"
            max-height="100%"
            @fclick="goToHome"
          />
        </v-col>
        <v-col cols="auto">
          <span class="title">{{ AppName }}</span>
        </v-col>
      </v-row>
    </v-container>
    <!--<v-toolbar-title-->
    <!--  v-show="!AppIsSmall"-->
    <!--  class="px-1 pointer pe-sm-5"-->
    <!--  @click="goToHome"-->
    <!--&gt;-->
    <!--  {{ AppName }}-->
    <!--</v-toolbar-title>-->
    <v-spacer />
    <!--<template v-if="!AppIsSmall">-->
    <v-spacer />
    <v-col
      class="pa-0"
      cols="auto"
    >
      <!--<app-language-menu />-->
      <template
        v-for="(item, i) in AppLocales.filter(e=>e.code !== AppLocale)"
      >
        <v-btn
          v-if="item.code !== AppLocale"
          :key="i"
          :value="item.code"
          text
          @click="SetAppLocale(item.code)"
        >
          {{ item.code }}
        </v-btn>
      </template>
      <app-notifications-menu v-if="authUser" />
      <v-btn
        v-if="showToggleTheme"
        icon
        @click="themeDark = !themeDark"
      >
        <v-icon>mdi-palette</v-icon>
      </v-btn>
      <v-btn
        v-if="authUser"
        icon
        @click.stop="logout"
      >
        <v-icon>logout</v-icon>
      </v-btn>
    </v-col>
    <!--</template>-->
  </v-app-bar>
</template>

<script>

export default {
  name: 'Bar',
  props: {
    navigation: {
      type: Boolean,
      default: () => undefined
    },
    hideDrawerIcon: {
      type: Boolean,
      default: () => !1
    },
    showToggleTheme: {
      type: Boolean,
      default: () => !1
    }
  },
  computed: {
    showDrawerIcon () {
      return !this.hideDrawerIcon
      // return this.AppIsSmall
    },
    drawer: {
      get () {
        return this.navigation
      },
      set (v) {
        this.$emit('update:navigation', Boolean(v))
      }
    }
  },
  methods: {
    logout () {
      this.confirmMessage(this.$t('messages.sure_logout'), async () => {
        await this.apiService.auth.logout({ push_token: window.push_token || null }).finally(() => this.logoutUser(true))
      }, () => {
      })
    },
    goToHome () {
      // const name = !this.authUser ? this.APP_ROUTES.homePage : this.APP_ROUTES.user.home
      const name = this.APP_ROUTES.homePage
      this.navigate(name)
    }
  }
}
</script>
<style>
.app-bar .v-toolbar__content {
  /*padding-left: 0 !important;*/
  /*padding-right: 0 !important;*/
}
</style>
